import { render, staticRenderFns } from "./Sitemap.vue?vue&type=template&id=0fa9be46&scoped=true&"
import script from "./Sitemap.vue?vue&type=script&lang=js&"
export * from "./Sitemap.vue?vue&type=script&lang=js&"
import style0 from "./Sitemap.vue?vue&type=style&index=0&id=0fa9be46&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa9be46",
  null
  
)

export default component.exports